import { ReactNode, MouseEvent } from "react"
import cn from "classnames"

interface ItemProps {
    children: ReactNode
    className?: string
    onClick?: (event: MouseEvent<HTMLDivElement>) => void
}

export function Item({ children, className, onClick }: ItemProps) {
    return (
        <div className={cn("mobile-navigation__item", className)} onClick={onClick}>
            {children}
        </div>
    )
}
